module.exports = __webpack_public_path__ + "static/media/tick.0c4cd319.png";